import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TeamMemberService', TeamMemberService);

  TeamMemberService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'UploadService',
  ];

  function TeamMemberService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    UploadService
  ) {
    const utils = new UtilService(this);

    $translate = $filter('translate');

    const apiUrl = `${environment.apiEndpoint}team_members`;

    var service = {
      changeTeamMemberStatus: changeTeamMemberStatus,
      getFilterCriteria: getFilterCriteria,
      updateTeamMembers: updateTeamMembers,
      deleteTeamMember: deleteTeamMember,
      getTeamMembers: getTeamMembers,
      saveTeamMember: saveTeamMember,
      getTeamMember: getTeamMember,
      updateLogo: updateLogo,
      openLogo: openLogo,
    };

    return service;

    function getFilterCriteria() {
      const filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filter;
    }

    function getTeamMembers(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: utils.cleanItemsCache(response.data, 'logo'),
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getTeamMember(id, params) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTeamMember(item, cropedImage) {
      const itemAddedMsg = $translate('NEW_ADDED_TEAM_MEMBER');
      const itemModifiedMsg = $translate('MODIFIED_TEAM_MEMBER');

      let method = item.id ? 'PUT' : 'POST';
      let url = item.id ? `${apiUrl}/${item.id}` : apiUrl;

      item.company_id = SessionService.getSelectedAccountCompany().id;

      return UploadService.uploadFile(
        method,
        url,
        'team_member',
        item,
        cropedImage,
        function () {},
        function (response) {
          let msg = item.id ? itemModifiedMsg : itemAddedMsg;
          utils._successMsg($translate(msg));

          return response;
        },
        function () {}
      );
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack, 220, 220);
    }

    // Update logo after crop
    function updateLogo(item, cropedImage) {
      let url = `${apiUrl}/${item.id}?lang=${config.DEFAULT_CONTENT_LANGUAGE}`;

      utils.updateLogo(url, 'team_member', item, cropedImage);
    }

    function deleteTeamMember(item, successCallback) {
      let url = `${apiUrl}/${item.id}`;

      return RestResource.request(
        'delete',
        `${url}?check_if_used=true`,
        {},
        function () {
          let params = {
            title: 'DELETE_TEAM_MEMBER',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            confirmButtonLabel: 'DELETE_TEAM_MEMBER',
            successMsg: 'DELETED_TEAM_MEMBER',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeTeamMemberStatus(item) {
      let url = `${apiUrl}/${item.id}?set_status=true`;

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function updateTeamMembers(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }
  }
})();
